import { useState } from "react";
import { useTranslation } from "react-i18next";
import useAnimateCss from "../../hooks/useAnimateCss";
import MainHeader from "../../components/layout/MainHeader";
import PageHeader from "../../components/layout/PageHeader";
import Footer from "../../components/layout/Footer";
import RebarTab from "../../components/products/RebarTab";
import BilletTab from "../../components/products/BilletTab";
import headerImg from "../../assets/images/background/13a.jpg";
import heroImg from "../../assets/images/misc/men-in-location-2.webp";


function Products() {
  const { t, i18n } = useTranslation();
  const [activeProduct, setActiveProduct] = useState<"rebar" | "billet">("rebar");

  const heroImgRef   = useAnimateCss("animate__fadeInLeft",  0,   0.1,  900);
  const heroLabelRef = useAnimateCss("animate__fadeInDown",  0,   0.15);
  const heroHeadRef  = useAnimateCss("animate__fadeInUp",    120, 0.15);
  const heroPara1Ref = useAnimateCss("animate__fadeInUp",    220, 0.15);
  const heroPara2Ref = useAnimateCss("animate__fadeInUp",    310, 0.15);
  const heroPara3Ref = useAnimateCss("animate__fadeInUp",    390, 0.15);
  const tabNavRef    = useAnimateCss("animate__fadeInDown",  0,   0.15);
  const ctaRef       = useAnimateCss("animate__bounceIn",    0,   0.15, 700);

  const catalogueUrl =
    i18n.language === "ar"
      ? "https://drive.google.com/file/d/19Cz6-8xajh_-xfyydhJXhylxXp4oNVAc/view?usp=sharing"
      : "https://drive.google.com/file/d/1NjGDFYygvJ8w_69pxl7WsJ6FEbRE3niH/view?usp=sharing";

  return (
    <>
      <MainHeader />
      <PageHeader image={headerImg} title={t("Products")} />

      {/* ── Hero ── */}
      <section className="products-hero-section">
        <div className="container">
          <div className="row align-items-center g-5">
            <div className="col-lg-6">
              <img
                src={heroImg}
                alt="Al Madina Steel Products"
                className="products-hero-img"
                ref={heroImgRef as any}
              />
            </div>
            <div className="col-lg-6">
              <span className="products-hero-label" ref={heroLabelRef as any}>{t("products-hero-label")}</span>
              <h2 className="products-hero-heading" ref={heroHeadRef as any}>{t("products-hero-heading")}</h2>
              <p className="products-hero-text" ref={heroPara1Ref as any}>{t("products-hero-p1")}</p>
              <p className="products-hero-text" ref={heroPara2Ref as any}>{t("products-hero-p2")}</p>
              <p className="products-hero-text" ref={heroPara3Ref as any}>{t("products-hero-p3")}</p>
            </div>
          </div>
        </div>
      </section>

      {/* ── Product switcher ── */}
      <div className="products-tab-nav" ref={tabNavRef as any}>
        <button
          type="button"
          className={`products-tab-btn${activeProduct === "rebar" ? " active" : ""}`}
          onClick={() => setActiveProduct("rebar")}
        >
          {t("Rebar")}
        </button>
        <button
          type="button"
          className={`products-tab-btn${activeProduct === "billet" ? " active" : ""}`}
          onClick={() => setActiveProduct("billet")}
        >
          {t("Billet")}
        </button>
      </div>

      {activeProduct === "rebar" ? <RebarTab /> : <BilletTab />}

      {/* ── View Catalogue ── */}
      <section className="container products-catalogue-cta" ref={ctaRef as any}>
        <div className="container text-center">
          <a
            href={catalogueUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="catalogue-icon-link"
          >
            <span className="catalogue-icon-link__icon">
              <svg aria-hidden="true" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
                <path d="M432,320H400a16,16,0,0,0-16,16V448H64V128H208a16,16,0,0,0,16-16V80a16,16,0,0,0-16-16H48A48,48,0,0,0,0,112V464a48,48,0,0,0,48,48H400a48,48,0,0,0,48-48V336A16,16,0,0,0,432,320ZM488,0h-128c-21.37,0-32.05,25.91-17,41l35.73,35.73L135,320.37a24,24,0,0,0,0,34L157.67,377a24,24,0,0,0,34,0L435.28,133.32,471,169c15,15,41,4.5,41-17V24A24,24,0,0,0,488,0Z" />
              </svg>
            </span>
            <span className="catalogue-icon-link__text">{t("View Catalogue")}</span>
          </a>
        </div>
      </section>

      <Footer />
    </>
  );
}

export default Products;
